import React, { Suspense } from 'react';

/**
 * Creates a lazy-loaded component with retry capability
 * @param {Function} importFn - Dynamic import function
 * @param {number} retries - Number of retry attempts (default: 3)
 * @returns {React.LazyExoticComponent}
 */
export function lazyWithRetry(importFn, retries = 3) {
  return React.lazy(() => {
    return new Promise((resolve, reject) => {
      const attempt = (retriesLeft) => {
        importFn()
          .then(resolve)
          .catch((error) => {
            if (retriesLeft > 0) {
              setTimeout(() => attempt(retriesLeft - 1), 1000);
            } else {
              reject(error);
            }
          });
      };
      attempt(retries);
    });
  });
}

/**
 * Wrapper component providing Suspense with fallback
 * @param {Object} props
 * @param {React.ReactNode} props.children - Lazy component to render
 * @param {React.ReactNode} props.fallback - Loading fallback component
 */
export function LazyBoundary({ children, fallback }) {
  return (
    <Suspense fallback={fallback}>
      {children}
    </Suspense>
  );
}
